import { createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    background: {
      default: 'rgba(0, 0, 0, 0.10)',
    },
  },
  components: {
    // iOS Safari auto-zooms the page whenever a focused form control's text is under 16px. This app
    // deliberately shrinks mobile typography (see `typography` below) and MUI's `size="small"` inputs
    // are 14px, so every input tripped it. There's no way to opt out of the zoom -- only to stay at or
    // above the threshold -- so force every input's text to exactly 16px here. `.MuiInputBase-input`
    // is the shared text slot for TextField, OutlinedInput, InputBase, Select, and Autocomplete, so
    // this one override covers all of them.
    MuiInputBase: {
      styleOverrides: {
        input: { fontSize: '16px' },
      },
    },
  },
  typography: {
    h1: { '@media (max-width:899.95px)': { fontSize: '4.8rem' } },
    h2: { '@media (max-width:899.95px)': { fontSize: '3rem' } },
    h3: { '@media (max-width:899.95px)': { fontSize: '2.4rem' } },
    h4: { '@media (max-width:899.95px)': { fontSize: '1.7rem' } },
    h5: { '@media (max-width:899.95px)': { fontSize: '1.2rem' } },
    h6: { '@media (max-width:899.95px)': { fontSize: '1rem' } },
    subtitle1: { '@media (max-width:899.95px)': { fontSize: '0.8rem' } },
    subtitle2: { '@media (max-width:899.95px)': { fontSize: '0.7rem' } },
    body1: { '@media (max-width:899.95px)': { fontSize: '0.8rem' } },
    body2: { '@media (max-width:899.95px)': { fontSize: '0.7rem' } },
    button: { '@media (max-width:899.95px)': { fontSize: '0.7rem' } },
    caption: { '@media (max-width:899.95px)': { fontSize: '0.6rem' } },
    overline: { '@media (max-width:899.95px)': { fontSize: '0.6rem' } },
  },
});

export default theme;
